import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';
import Request from '../../utils/request';

const SELECTOR_PAGE = '.js-my-favourites';
const SELECTOR_RECENT_VENUE_LIST = '.js-recent-venues-grid';
const SELECTOR_AFFILIATED_VENUE_LIST = '.js-affiliated-venues-grid';
const SELECTOR_CARD = '.lta-game-venue-card';
const SELECTOR_CARD_TITLE = '.venue-card-title';
const SELECTOR_CARD_ADDRESS = '.venue-card-address';
const SELECTOR_CARD_BUTTON = '.js-remove-fav-venue';
const SELECTOR_MODAL = '#my-favourite-venue-modal';
const SELECTOR_MODAL_REMOVE = '.js-my-favourite-venue-remove';
const SELECTOR_MODAL_CANCEL = '.js-my-favourite-venue-cancel';
const SELECTOR_MODAL_TITLE = '.venue-modal-title';
const SELECTOR_MODAL_ADDRESS = '.venue-modal-address';

const EVENT_CLICK = `click`;

class FavouriteVenue {
	constructor() {
		this._myContactId = undefined;
		this.removingCard = undefined;
		this._venueFavouriteCard = undefined;
		this.init();
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);
		if (!this._wrapperElement) {
			return;
		}
		this._myContactId = this._wrapperElement.getAttribute('data-my-favourites-contact-id');
		this._removeVenue = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapperElement);
		this._recentVenuesList = SelectorEngine.findOne(SELECTOR_RECENT_VENUE_LIST, this._wrapperElement);
		this._affiliatedVenuesList = SelectorEngine.findOne(SELECTOR_AFFILIATED_VENUE_LIST, this._wrapperElement);
		this._removeVenueModal = new Modal(this._removeVenue, {});

		if (this._removeVenueModal) {
			const _venueFavouriteRemove = SelectorEngine.findOne(SELECTOR_MODAL_REMOVE, this._removeVenue);
			const _venueFavouriteCancel = SelectorEngine.findOne(SELECTOR_MODAL_CANCEL, this._removeVenue);

			EventHandler.on(_venueFavouriteRemove, EVENT_CLICK, () => {
				// TO DO: This id will be used to delete card
				// console.log("Selected card : " , this.removingCard.id);
				this.removeFavouriteVenue();
			});

			EventHandler.on(_venueFavouriteCancel, EVENT_CLICK, this.hideRemoveVenueModal.bind(this));
		}
		this.fetchCount();
	}

	async removeFavouriteVenue() {
		const postData = { 
			'ContactId': this._myContactId, 
			'venue': [this.removingCard.children[0].getAttribute('data-current-venue-id')] 
		};
		const deleteVenue = await Request.post('/api/selfsubmission/deleteRecentVenue', postData).catch(e => {
			console.log(error);
		});

		if(deleteVenue.errors.errorcode == '00') {
			this.hideRemoveVenueModal();
		}
	}

	set data(data) {
		this._data = data;
		this.render();
		this.bindEvents();
	}
 
	bindEvents() {
		this._venueFavouriteCard = SelectorEngine.find(SELECTOR_CARD, this._wrapperElement);

		this._venueFavouriteCard.forEach((card) => {
			const _venueFavouriteCardButton = SelectorEngine.findOne(SELECTOR_CARD_BUTTON, card);
			EventHandler.on(_venueFavouriteCardButton, EVENT_CLICK, (event) => {
				this.showRemoveVenueModal(card);
			});
		});
	}

	get data() {
		return this._data;
	}

	async fetchCount() {
		//try {
			// USE FOR PRODUCTION
			const result = await Request.get(`/api/selfsubmission/getRecentVenueByContactId?contactId=${this._myContactId}`
			).catch( error => console.log(error))

			// USE FOR DEV
			// const result = await fetch(`http://dev-verolt.azurewebsites.net/api/selfsubmission/getRecentVenueByContactId?contactId=0038E00001KwMhnQAF`);
			const response = await result;

			if (response.errors.errorcode == '00') {
				this.data = response.response;
			}
			try {
				if (response.errors.errorcode == '01') {
					this.data = response.response;
				}
			} catch(error) {
				console.error(error);
			}
			
		// } catch (error) {
		// 	console.log(error);
		// }
	}

	showRemoveVenueModal(card) {
		this.removingCard = card;
		const modalBodyTitle = SelectorEngine.findOne(SELECTOR_MODAL_TITLE, this._removeVenue);
		const cardTitle = SelectorEngine.findOne(SELECTOR_CARD_TITLE, card);

		const modalBodyAddress = SelectorEngine.findOne(SELECTOR_MODAL_ADDRESS, this._removeVenue);
		const cardAddress = SelectorEngine.findOne(SELECTOR_CARD_ADDRESS, card);

		modalBodyTitle.innerHTML = cardTitle.innerHTML;
		modalBodyAddress.innerHTML = cardAddress.innerHTML.replace(',', '<br/>');
		this._removeVenueModal.show();
	}

	hideRemoveVenueModal() {
		this.removingCard = null;
		this._removeVenueModal.hide();
		this.bindEvents();
		this.fetchCount();
	}

	render() {
		this._affiliatedVenuesList.innerHTML = this.renderAffiliatedVenue(this.data.affiliatedVenues);
		this._recentVenuesList.innerHTML = this.renderRecentVenue(this.data.recentVenues);
	}

	renderRecentVenue(recentVenues){
		const favouriteVenueCardRenderData = recentVenues
			.map((item) => {
				const rowItem = {};
				(rowItem.title = item.name),
					(rowItem.address = item.address),
					(rowItem.showButton = true),
					(rowItem.id = item.id);
				return this.renderVenueRow(rowItem);
			})
			.join('');
		return favouriteVenueCardRenderData;
	}

	renderAffiliatedVenue(affiliatedVenue){
		const affiliatedVenueCardRenderData = affiliatedVenue
			.map((item) => {
				const rowItem = {};
				(rowItem.title = item.name),
					(rowItem.address = item.address),
					(rowItem.showButton = false),
					(rowItem.id = item.id);
				return this.renderVenueRow(rowItem);
			})
			.join('');
		return affiliatedVenueCardRenderData;
	}

	renderVenueRow(itemData) {
		let buttonHtml = itemData.showButton ? `<div><button type="button" 
			class="lta-btn lta-btn--md lta-btn--button lta-btn--icon lta-btn--icon-before lta-btn--xs u-p-1 js-remove-fav-venue u-label1 u-text-grey-dark-slate u-rounded u-border u-border-2" title="Remove">
			<svg class="lta-icon js-lta-text-input--btn-icon" width="1.30em" height="1.30em" fill="currentColor" alt="close" aria-hidden="true">
				<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
			</svg>Remove</button></div>` : ``;

		let cardClass = itemData.showButton ? 'u-bg-background-blue u-text-lta-dark-blue' : 'u-bg-lta-dark-blue u-text-white'

		return `<div class="lta-card lta-game-venue-card u-mb-3 u-px-3 u-py-2 u-rounded u-body2 u-label1 ${cardClass}">
				<input type="hidden" data-current-venue-id=${itemData.id} />
				 <p class="u-text-left u-mb-2">
				 	<b class="venue-card-title">${itemData.title}</b><br>
					<span class="venue-card-address">${itemData.address.street}<br>
					${itemData.address.city}<br>
					${itemData.address.country}<br>
					${itemData.address.postalcode}<br>
					</span>
				</p>
				${buttonHtml}
			  </div>`;
	}
}

const globalFavouriteVenue = new FavouriteVenue();
export default globalFavouriteVenue;
